import { render, staticRenderFns } from "./CKEditorWrapper.vue?vue&type=template&id=a763aa48&scoped=true&"
import script from "./CKEditorWrapper.vue?vue&type=script&lang=ts&"
export * from "./CKEditorWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CKEditorWrapper.vue?vue&type=style&index=0&id=a763aa48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a763aa48",
  null
  
)

export default component.exports